
import { Component } from "vue-property-decorator"
import { BestellungFiliale } from "mangdto"
import { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import { Prop } from "vue-property-decorator"

@Component
export default class Filiale extends mixins(Calculator) {
  @Prop() filiale: BestellungFiliale
}
